import { TagEventsEnum } from 'common/enums/TagEventsEnum'
import BaseBridge from 'config/bridge/BaseBridge'

export const analyticsRedemptionReceipt = (params?: Record<string, string>) => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    screen: 'comprovante',
    ref_figma: '5',
    ref_type: 'sucesso',
    content_action: 'dado carregado',
    action_id: 'Resgate solicitado',
    currency: 'BRL',
    product: 'capitalização',
    flow: 'resgate',
    ...params,
  })
}

export const analyticsRedemptionReceiptLoad = (params?: Record<string, string>) => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    screen_name: 'Sortezinha:Comprovante',
    product_area: 'Resgate',
    product: 'capitalização',
    flow: 'prateleira',
    ...params,
  })
}
